/*
 * cart-drawer-fix.js
 * Replaces the Pipeline theme's default "popdown banner" post-add-to-cart
 * behavior with the actual cart drawer sliding out.
 *
 * Why the deferred open: Pipeline fires `theme:cart:popdown` synchronously
 * after kicking off an async `/cart.js` fetch. If we opened the drawer on
 * popdown, it would render with stale cart data (no new item visible).
 * We wait for `theme:cart:change` (fired when the fetch completes) before
 * opening so the drawer always shows the latest cart state.
 */
(function () {
  'use strict';

  var DRAWER_SELECTOR = '[data-drawer="drawer-cart"]';
  var POPDOWN_SELECTOR = '[data-product-add-popdown-wrapper]';
  var WAIT_TIMEOUT_MS = 1500;

  function openDrawer() {
    var drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) return false;
    drawer.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
    drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    return true;
  }

  function hidePopdown() {
    var popdown = document.querySelector(POPDOWN_SELECTOR);
    if (popdown) popdown.classList.remove('is-visible');
  }

  // Wait for the next `theme:cart:change` event (cart data refreshed),
  // then open the drawer. Falls back after WAIT_TIMEOUT_MS in case the
  // event never fires.
  function openDrawerWhenCartReady() {
    var fired = false;
    function go() {
      if (fired) return;
      fired = true;
      openDrawer();
    }
    document.addEventListener('theme:cart:change', go, { once: true });
    setTimeout(go, WAIT_TIMEOUT_MS);
  }

  // Pipeline's standard ATC flow: popdown is the trigger we intercept.
  // Capture-phase listener runs first so we hide the banner before it paints.
  document.addEventListener('theme:cart:popdown', function () {
    hidePopdown();
    openDrawerWhenCartReady();
  }, true);

  // Bundle ATC path from pdp-bag-upsell.js bypasses Pipeline's handleSuccess.
  // Those handlers fetch /cart.js themselves and then fire these events.
  // They run AFTER the fetch resolves, so opening immediately is safe.
  document.addEventListener('cart:refresh', openDrawer);
  document.addEventListener('cart:updated', openDrawer);
  document.addEventListener('ajaxProduct:added', openDrawer);
})();
